import React from "react";
import { ListContainer, ListContent, ListItem, ListNumber } from "./List.styles";

export interface CustomListProps {
    elements: string[] | React.ReactElement[];
    ordered?: boolean;
}

export const List = ({
    elements,
    ordered = true,
    ...rest
}: CustomListProps) => {
    return (
        <ListContainer>
            {elements.map((element, index) => (
                <ListItem key={index}>
                    <ListNumber>
                        {index + 1}
                    </ListNumber>
                    <ListContent >
                        {element}
                    </ListContent>
                </ListItem>
            ))}
        </ListContainer>
    );
};

export interface ListProps extends React.ComponentProps<typeof List> {
    as?: React.ElementType;
}

List.displayName = "List";